import React from "react";

const Pdf = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="4" fill="#1A6D73" />
      <path
        d="M41.0748 28.7146C40.1105 27.6431 37.9677 27.1074 35.0748 27.1074C33.3605 27.1074 31.5391 27.3217 29.3962 27.6431C27.1273 25.518 25.2425 23.0169 23.8248 20.2503C24.8962 17.036 25.6462 13.9289 25.6462 11.5717C25.6462 9.75028 25.0034 6.85742 22.432 6.85742C21.682 6.85742 21.0391 7.28599 20.6105 7.92885C19.5391 9.85742 19.9677 14.1431 22.0034 18.6431C20.5163 22.9431 18.7261 27.1322 16.6462 31.1789C10.9677 33.536 7.21767 36.1074 6.89624 38.1431C6.68196 39.1074 7.32482 40.7146 9.57482 40.7146C12.8962 40.7146 16.5391 35.8931 19.3248 30.9646C22.5406 29.8588 25.8358 28.9992 29.182 28.3931C33.2534 31.9289 36.7891 32.4646 38.5034 32.4646C41.932 32.4646 42.2534 30.0003 41.0748 28.7146ZM21.1462 8.25028C22.0034 6.96456 23.932 7.39314 23.932 9.96456C23.932 11.6789 23.3962 14.4646 22.3248 17.6789C20.3962 13.1789 20.3962 9.64314 21.1462 8.25028ZM7.5391 38.2503C7.86053 36.536 11.0748 34.1789 16.1105 32.1431C13.3248 36.8574 10.5391 39.8574 8.82482 39.8574C7.75339 39.8574 7.43196 38.8931 7.5391 38.2503ZM28.6462 27.7503C25.6273 28.3129 22.6547 29.1008 19.7534 30.1074C21.3392 27.2451 22.6315 24.2298 23.6105 21.1074C25.0188 23.5142 26.7093 25.7443 28.6462 27.7503ZM30.0391 28.1789C33.4677 27.6431 36.3605 27.7503 37.6462 27.9646C40.7534 28.6074 39.682 32.3574 36.2534 31.5003C33.7891 30.9646 31.7534 29.5717 30.0391 28.1789Z"
        fill="white"
      />
    </svg>
  );
};

export default Pdf;
